import React from 'react';
import { CHECKOUT_PLANS } from '../../../../utils/checkoutPlan/constants';
import MilestoneFooterInfo from './MilestoneFooterInfo';

export const FOOTER_CONFIG = {
    [CHECKOUT_PLANS.SINGLE_ORDER]: {
        FooterInfo: () => null,
    },
    [CHECKOUT_PLANS.MILESTONES_ORDER]: {
        FooterInfo: () => <MilestoneFooterInfo />,
    },
    [CHECKOUT_PLANS.RECURRING_ORDER]: {
        FooterInfo: () => null,
    },
};
